import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
  :host {
    display: block;

    --com-calendar-date-height: 70px;
    --com-calendar-date-selected-scale-rate: 1;
    --com-calendar-fuse-height: 43px;
    --com-calendar-fuse-padding-top: 3px;
  }

  #calendarWrapper {
    display: inline-block;
  }

  .comCalendar {
    display: flex;
    position: relative;
  }

  :host([use-grid-display-style]) .comCalendar {
    flex-wrap: wrap;
    justify-content: left;
  }

  #rowEnd {
    flex-basis: 100%
  }

  .calendarItems {
    max-width: var(--com-calendar-max-width, auto);
    width: var(--com-calendar-width, auto);
  }

  :host([adaptive="xs"]) .calendarItems {
    width: auto;
  }

  .reservationCalendar {
    flex: 1;
    padding: 10px;
  }

  :host([adaptive="xs"][use-grid-display-style]) .reservationCalendar {
    flex: 1;
    padding: 16px 3px;
  }

  :host([use-grid-display-style]) .reservationCalendar {
    flex: 0;
    padding: 19px 4px 28px;
  }

  .dateTypeIndicator {
    min-height: 20px;
    text-align: center;
    line-height: 10px;
    color: #DD1788;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
  }

  .dateTypeIndicator.primary,
  .dateTypeIndicator.all {
    image-rendering: -webkit-optimize-contrast;
  }

  :host([use-grid-display-style]) .dateTypeIndicator {
    min-height: 10px;
    max-height: 10px;
  }

  .dateTypeIndicatorIcon {
    min-height: 20px;
    text-align: center;
    line-height: 10px;
    color: #DD1788;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    padding-top: 2px;
    @apply --type14;
  }

  .legendItem {
    align-items: var(--com-calendar-legend-date-indicator-align-items, baseline);
    padding:  var(--com-calendar-legend-padding, 0);
  }

  .legendItem .dateTypeIndicatorIcon {
    margin: var(--com-calendar-legend-date-indicator-icon-margin, 0 10px 0 0);
  }

  .comCalendar .dateTypeIndicatorIcon {
    padding: var(--com-calendar-date-indicator-icon-padding, 2px 0 0 0);
  }

  .dateTypeIndicatorIcon.none,
  .dateTypeIndicatorIcon.ternary {
    color: var(--com-calendar-date-disabled-color, #ACBAC1);
  }

  :host([use-grid-display-style]) .dateTypeIndicatorIcon {
    min-height: 10px;
    max-height: 10px;
    font-size: 10px;
  }

  .dateTypeIndicator.all {
    color: #00233C;
    font-size: var(--com-calendar-price-size, 10px);
  }

  .dateTypeIndicator.primary svg,
  .dateTypeIndicator.all svg {
    width: var(--com-calendar-indicator-svg-width, 10px);
  }

  .dateTypeIndicator.primary,
  .dateTypeIndicatorIcon.primary {
    color: #DD1788;
  }

  .dateTypeIndicator.secondary,
  .dateTypeIndicatorIcon.secondary {
    color: #008896;
  }

  .dateTypeIndicator.green,
  .dateTypeIndicatorIcon.green,
  .dateTypeIndicator.all.green,
  .dateTypeIndicatorIcon.all.green {
    color: #008900;
  }

  .dateTypeIndicator.no-reservations,
  .dateTypeIndicatorIcon.no-reservations {
    color: var(--com-calendar-date-disabled-color, #ACBAC1);
  }

  .dateTypeIndicatorIcon.no-reservations {
    font-size: var(--com-calendar-no-reservation-icon-font-size, 14px);
  }

  .dateTypeIndicator.bonus-day,
  .dateTypeIndicatorIcon.bonus-day {
    color: #F4AF25;
  }

  .overlapping {
    position: relative;
    text-align: center;
    padding-right: 7px;
    max-height: 22px;
  }

  :host([use-grid-display-style]) .overlapping {
    display: flex;
    max-height: 10px;
  }

  :host([use-grid-display-style]) .overlappingInner {
    margin: 0 auto;
  }

  .overlappingInner {
    position: relative;
    display: inline-block;
  }

  .overlapping .overlappingInner .dateTypeIndicatorIcon {
    text-align: left;
    justify-content: left;
  }

  .overlapping .secondIcon {
    margin-right: 0;
  }

  .overlapping .firstIcon {
    top: 0;
    position: absolute;
    left: 8px;
    background: transparent;
  }

  .dateTypeIndicator.circle {
    align-items: flex-end;
    line-height: 13px;
    font-size: 17px;
    color: #008896;
  }

  .dateTypeIndicator.blocked .slash,
  .dateTypeIndicator.unavailable .slash,
  .dateTypeIndicator.none .slash {
    display: block;
    width: var(--com-calendar-legend-slash-dimension, 12px);
    height: var(--com-calendar-legend-slash-dimension, 12px);
    top: 15%;
    left: 15%;
    margin-right: 5px;
    padding-left: 1px;
  }

  :host([use-grid-display-style]) .dateTypeIndicator.unavailable {
    display: none;
  }

  .dateTypeIndicator.blocked .slash line,
  .dateTypeIndicator.unavailable .slash line,
  .dateTypeIndicator.none .slash {
    stroke-linecap: round;
    stroke-width: 2;
    color: var(--com-calendar-date-disabled-color, #ACBAC1);
    stroke: var(--com-calendar-date-disabled-color, #ACBAC1);
  }

  :host([adaptive="xs"]) .legends {
    flex-direction: column;
  }

  :host([adaptive="xs"]) .legends.sameLine {
   row-gap: 0;
  }

  :host([adaptive="xs"]) .legendItem {
    margin-top: var(--com-calendar-legend-item-margin-top, 10px);
  }

  #endMessage {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    max-width: 400px;
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 12px;
    margin-left: 12px;
    color: var(--com-calendar-end-message-color, var(--primary-active));
    @apply --type16;
  }

  #endMessageHeader {
    text-align: center;
    margin-bottom: 16px;
    @apply --type24;
    @apply --heavy;
  }

  :host([adaptive="xs"]) #endMessageHeader {
    @apply --type20;
    @apply --black;
  }

  :host([adaptive="xs"]) #endMessage {
    @apply --type16;
  }

  #drawer {
    padding: 16px;
  }
  svg[disabled] {
    display: none;
  }
  .calendarNav {
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 10px;
    width: 100%;
    padding: var(--com-calendar-nav-padding, 0 10px);
    box-sizing: border-box;
    max-width: var(--com-calendar-nav-max-width, 100%);
  }
  :host([adaptive="xs"]) .calendarNav {
    max-width: var(--com-calendar-nav-mobile-max-width, 404px);
  }
  :host #prevArrow,
  :host #nextArrow {
    margin: var(--com-calendar-date-compact-nav-arrow-styles, 0);
    padding: 1px 5px;
    @apply --type18;
  }
  /* when swiping, year/month text will go under the arrows */
  :host([navigation="swipe-and-tap"]) #prevArrow,
  :host([navigation="swipe-and-tap"]) #nextArrow {
    background-color: white;
    @apply --type20;
    font-weight: 400;
  }

</style>
</template>`;

styleElement.register('com-calendar-style');